export function isButtonEmpty(props) {
    return !props || !props.text || !props.link;
}
